import { render } from "./AddCertificateComponent.vue?vue&type=template&id=466bb0e2&scoped=true"
import script from "./AddCertificateComponent.vue?vue&type=script&lang=js"
export * from "./AddCertificateComponent.vue?vue&type=script&lang=js"

import "./AddCertificateComponent.vue?vue&type=style&index=0&id=466bb0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466bb0e2"]])

export default __exports__